<template>
		<div class="content" style="padding-bottom: 0;">
      <Header></Header>
      <div class="nav">
      	<span class="">{{$t('buyPack')}}</span>
      </div>
      <div class="buy-info">
        <div class="mission-content" style="width: 95%">
          <div class="list mt30">
            <div class="li"  @click="showBuyPopup()">
              <div class="lf">
                <img src="../../static/images/fen2.png" />
                <strong>{{$t('one_time_package')}}</strong>
              </div>
              <div class="rf">
                {{$t('OneTimeChance')}}  >>
              </div>
            </div>
            <div class="li1" >
              <div class="lf">
                <strong>{{$t('daily_pack')}}<br />
                  <div  v-html="$t('daily_tip')"></div>
                </strong>
              </div>
              <div class="rf">
                {{$t('dailyM')}}
              </div>
            </div>
            <div class="li1"  >
              <div class="lf">
                <strong>{{$t('weekly_pack')}}<br />
                  <div  v-html="$t('weekly_tip')"></div>
                </strong>
              </div>
              <div class="rf">
                {{$t('weeklyM')}}
              </div>
            </div>
            <div class="li1"  >
              <div class="lf">
                <strong>{{$t('monthly_pack')}}<br />
                  <div  v-html="$t('monthly_tip')"></div>
                </strong>
              </div>
              <div class="rf">
                {{$t('monthlyM')}}
              </div>
            </div>

          </div>

          <div style="text-align: center;font-size: 30px;margin-top: 20px;margin-bottom: 20px;height: 190px;" v-html="$t('sub_tip')">

          </div>
        </div>
      </div>
      <!-- 购买确认弹窗-->
      <Dialog ref="buyDialog" type="alert" :callback="getBuy" title="Reminder" width="100" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <div class="pt20 ac" style="padding-top:10px;font-weight: 700;">
              {{ $t('buy_popup_tip1') }}
            </div>
            <img style="width: 80%; margin: 30px 0 -10px;" src="../../static/images/robot-img.png">
            <div class="" style="margin-top: 120px;font-size: 24px;">
              <div class="" style="width: 70%;margin: 10px auto 30px;">{{$t('buy_popup_tip2')}}</div>
            </div>
            <button class="btn6 font-family mt20" style="width: 280px;line-height: 103px;color: #fff;font-size: 30px;" @click="closeBuyPopup">{{$t('cancel')}}</button>
            <button style="width: 280px;height: 104px;" class="btn-yl font-family mt20" @click="getBuy()">{{$t('buyNow')}}</button>
          </div>
        </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/header'
import Footer from '../components/footer'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog,Footer
    },
    data() {

    return {
			info:{},
      invited_code:'',
      invitedAlert:'',
      answerReson:{}
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},
    answerModal(){

    },
		getBuy(){
			let that =this;
			that.$parent.loadModal(true);
			that.$api.get('/api/index/buy',null,r =>{
				that.$parent.returnCode(r,function(){
         that.$parent.loadModal(false);
          that.$utils.alertText(r.msg);
        });

			})
		},
      showBuyPopup(){
        this.$refs.buyDialog.showMaskFun();
      },
      closeBuyPopup(){
        this.$refs.buyDialog.closeMask();
      },
    copy(item){
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$utils.alertText(this.$t('CopySucceeded'));
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          //console.log("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
    }
	}
}
</script>
<style>
.invited-c {
  background: url(../../static/images/invited-bg.jpg) no-repeat center top;
  color: #fff;
  padding: 40px;
  margin: 0 auto;
  border-radius: 40px;
  font-family: arial;
  text-align: left;
  width: 680px;
  height: 893px;
}

.mt30{margin-top:30px !important;}
.list .li{background: linear-gradient(90deg,#6bd3ff,#6fabff,#2c7dff,#ff64be,#f30b92);border-radius: 10px;color:#fff;display: flex;justify-content:space-between;padding:40px;margin: 30px 0 0;align-items: center;}
.list .li1{background: #808080ba;border-radius: 10px;color:#fff;display: flex;justify-content:space-between;padding:40px;margin: 30px 0 0;align-items: center;}
.lf{display: flex;justify-content: space-between;align-items: center;}
.lf img{height:50px;margin-right: 20px;}
.list .li.disabled{background: #3f4567;color: #828282;}
.li.disabled img{filter: grayscale(100%);}
</style>



// WEBPACK FOOTER //
// src/page/buyPack.vue